function PaymentRedirectForm(Checksum) {
  console.log(Checksum);

  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute(
    "action",
    "https://heapp21.hdfcergo.com/UAT/OnlineProducts/CCPGISUBSCRIBER/MakePayment.aspx "
  );

  const input1 = document.createElement("input");
  input1.setAttribute("type", "hidden");
  input1.setAttribute("name", "Trnsno");
  input1.setAttribute("value", Checksum.TransactionNo);
  form.appendChild(input1);

  const input2 = document.createElement("input");
  input2.setAttribute("type", "hidden");
  input2.setAttribute("name", "Amt");
  input2.setAttribute("value", Checksum.TotalAmount);
  form.appendChild(input2);

  const input3 = document.createElement("input");
  input3.setAttribute("type", "hidden");
  input3.setAttribute("name", "Appid");
  input3.setAttribute("value", Checksum.AppID);
  form.appendChild(input3);

  const input4 = document.createElement("input");
  input4.setAttribute("type", "hidden");
  input4.setAttribute("name", "Subid");
  input4.setAttribute("value", Checksum.SubscriptionID);
  form.appendChild(input4);

  const input5 = document.createElement("input");
  input5.setAttribute("type", "hidden");
  input5.setAttribute("name", "Surl");
  input5.setAttribute("value", Checksum.SuccessUrl);
  form.appendChild(input5);

  const input6 = document.createElement("input");
  input6.setAttribute("type", "hidden");
  input6.setAttribute("name", "Furl");
  input6.setAttribute("value", Checksum.FailureUrl);
  form.appendChild(input6);

  const input7 = document.createElement("input");
  input7.setAttribute("type", "hidden");
  input7.setAttribute("name", "Src");
  input7.setAttribute("value", Checksum.Source);
  form.appendChild(input7);

  const input8 = document.createElement("input");
  input8.setAttribute("type", "hidden");
  input8.setAttribute("name", "Chksum");
  input8.setAttribute("value", Checksum.checksum);
  form.appendChild(input8);

  document.body.appendChild(form);
  form.submit();

  return null;
}

export default PaymentRedirectForm;
